export default __webpack_public_path__ + "static/media/backArrowActive.7994e5d1.svg";